module.exports = __webpack_public_path__ + "img/giftcode.8c56af23.svg";